<template>
  <div class="ma-8">
    <a @click="$router.go(-1)" class="d-flex align-center ai-back">
      <v-icon right class="page-description ml-0 mr-2">mdi-chevron-left</v-icon> Назад
    </a>
    <BreadCrumbs :items="breadcrumbs" class="mt-3 ml-2 ai-breadcrumps"/>

    <div v-if="loading.loadProject">
      Загрузка...
      <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
    </div>
    <div v-else-if="!curProject" >
      Проект не найден
    </div>
    <div v-else>
      <div class="d-flex justify-space-between mb-6" style="max-width: 1000px;">
        <h2 class="page-title">{{ curProject.name }}</h2>
        <ProjectStatusIndicator :project="curProject" class="mt-2"/>
      </div>

      <v-btn v-for="(tabTitle, ind) in tabs" :key="ind" @click="tab = ind" class="mr-3 mb-2" :outlined="tab!==ind" color="primary" rounded>
        {{ tabTitle }}
      </v-btn>

      <v-card class="mt-6">
        <v-card-text>
          <v-tabs-items v-model="tab" class="transparent">
            <v-tab-item>
              <ViewProjectAbout />
            </v-tab-item>
            <v-tab-item>
              <ViewProjectAIExpert />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import ViewProjectAbout from './ViewProjectAbout.vue';
import ViewProjectAIExpert from './ViewProjectAIExpert';
import ProjectStatusIndicator from "./ProjectStatusIndicator"

export default {
  name: 'EditProjectPage',
  components: {
    ViewProjectAbout, ViewProjectAIExpert, ProjectStatusIndicator
  },
  data: () => ({
    tab: 0,
    tabs: ['О проекте', 'Анализ от AI-эксперта']
  }),
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        this.loadProject(id)
      }
    },  
  },
  computed: {
    ...mapGetters({
      loading: 'ai/hrprojects/loading',
      items: 'ai/hrprojects/items',
      curProject: 'ai/hrprojects/curProject',
    }),
    breadcrumbs() {
      return [
        { title: 'AI-эксперт', url: '/ai?tab=0' },
        { title: 'Проекты HR', url: '/ai?tab=1' },
        { title: this.curProject ? this.curProject.name : 'Проект не найден' },
      ]
    }
  },
  methods: {
    ...mapActions({
      loadProject: 'ai/hrprojects/loadProject',
    }),
  }
}
</script>

<style>


</style>
